import { PRICE_LIST } from "@/pricelist/pricelist";
const CRYPTO_PASSPHRASE = "Xti28b7k4eZUyc7HaCe7QJHgMjwKZ8LX8jKiLxX4";
const GENDER_LABELS = [
  { VALUE: 1, LABEL: "男性" },
  { VALUE: 2, LABEL: "女性" },
];
const PERSON_LABELS = [
  { ID: "p1", VALUE: 1, LABEL: "本人" },
  { ID: "p2", VALUE: 2, LABEL: "配偶者" },
  { ID: "p3", VALUE: 3, LABEL: "こども１" },
  { ID: "p4", VALUE: 4, LABEL: "こども２" },
];
const LIFESTAGE_LABELS = [
  { VALUE: 1, LABEL: "独身", IMG: "pict-single.svg" },
  { VALUE: 2, LABEL: "夫婦", IMG: "pict-couple.svg" },
  { VALUE: 3, LABEL: "ファミリー", IMG: "pict-family.svg" },
  { VALUE: 4, LABEL: "子供独立後", IMG: "pict-couple-senior.svg" },
];
const INS_PRODUCTS_LABELS = [
  {
    ID: "seimei",
    TITLE: "Kawasakiせいめい保険",
    AFTER_TITLE: "「死亡・高度障害リスク」に備える保険です。",
    CONDITIONS: [
      {
        ID: "course",
        NAME: "死亡保険金額",
        LABELS: [
          { VALUE: 1, LABEL: "100万円" },
          { VALUE: 2, LABEL: "200万円" },
          { VALUE: 3, LABEL: "300万円" },
          { VALUE: 4, LABEL: "500万円" },
          { VALUE: 5, LABEL: "700万円" },
          { VALUE: 6, LABEL: "1,000万円" },
          { VALUE: 7, LABEL: "1,500万円" },
          { VALUE: 8, LABEL: "2,000万円" },
          { VALUE: 9, LABEL: "2,500万円" },
          { VALUE: 10, LABEL: "3,000万円" },
          { VALUE: 11, LABEL: "3,500万円" },
          { VALUE: 12, LABEL: "4,000万円" },
          { VALUE: 13, LABEL: "4,500万円" },
          { VALUE: 14, LABEL: "5,000万円" },
        ],
        LABELS_SUB: [
          { VALUE: 1, LABEL: "100万円" },
          { VALUE: 2, LABEL: "200万円" },
          { VALUE: 3, LABEL: "300万円" },
          { VALUE: 4, LABEL: "500万円" },
          { VALUE: 5, LABEL: "700万円" },
          { VALUE: 6, LABEL: "1,000万円" },
          { VALUE: 7, LABEL: "1,500万円" },
          { VALUE: 8, LABEL: "2,000万円" },
          { VALUE: 9, LABEL: "2,500万円" },
          { VALUE: 10, LABEL: "3,000万円" },
        ],
        LABELS_CHILD: [
          { VALUE: 1, LABEL: "100万円" },
          { VALUE: 2, LABEL: "200万円" },
          { VALUE: 3, LABEL: "300万円" },
          { VALUE: 4, LABEL: "400万円" },
        ],
      },
    ],
  },
  {
    ID: "seikatsu",
    TITLE: "Kawasakiせいかつ保険",
    AFTER_TITLE: "「日常生活のリスク」を幅広くサポートします。",
    CONDITIONS: [
      {
        ID: "medical",
        NAME: "医療",
        LABELS: [
          { VALUE: 1, LABEL: "M1" },
          { VALUE: 2, LABEL: "M2" },
          { VALUE: 3, LABEL: "M3" },
          { VALUE: 4, LABEL: "M4" },
          { VALUE: 5, LABEL: "M1J" },
          { VALUE: 6, LABEL: "M2J" },
          { VALUE: 7, LABEL: "M3J" },
          { VALUE: 8, LABEL: "M4J" },
        ],
      },
      {
        ID: "cancer",
        NAME: "がん",
        LABELS: [
          { VALUE: 1, LABEL: "G1" },
          { VALUE: 2, LABEL: "G1S" },
          { VALUE: 3, LABEL: "G1K" },
          { VALUE: 4, LABEL: "G1KS" },
        ],
      },
      {
        ID: "nursing",
        NAME: "介護",
        LABELS: [
          { VALUE: 1, LABEL: "100万円" },
          { VALUE: 2, LABEL: "200万円" },
          { VALUE: 3, LABEL: "300万円" },
        ],
      },
      {
        ID: "injury",
        NAME: "傷害",
        OPTIONS: [
          {
            ID: "type",
            LABELS: [
              { VALUE: 1, LABEL: "個人型" },
              { VALUE: 2, LABEL: "家族型" },
            ],
            LABELS_SUB: [
              { VALUE: 1, LABEL: "個人型" },
            ],
            LABELS_CHILD: [
              { VALUE: 1, LABEL: "個人型" },
            ],
            // RADIO: true,
          },
          {
            ID: "disaster",
            LABELS: [
              { VALUE: 1, LABEL: "天災補償　あり" },
              { VALUE: 2, LABEL: "天災補償　なし" },
            ],
          },
          {
            ID: "amount",
            LABELS: [
              { VALUE: 1, LABEL: "1口" },
              { VALUE: 2, LABEL: "2口" },
              { VALUE: 3, LABEL: "3口" },
            ],
          },
        ],
        NOTE: "※団体構成員とそのご家族が「保険の対象となる方ご本人」としてご加入する場合、ご家族の保険金額が団体の構成員の保険金額を上回らないタイプおよび口数を選択してください。",
      },
      {
        ID: "compensation",
        NAME: "個人賠償責任",
        LABELS: [
          { VALUE: 1, LABEL: "あり" },
          { VALUE: 2, LABEL: "なし" },
        ],
      },
    ],
  },
  {
    ID: "shushin",
    BEFORE_TITLE: "さらに充実した補償が必要な方に",
    TITLE: "Kawasaki終身医療保険",
    AFTER_TITLE: "「病気・がん・ケガ」などのリスクをサポート",
    CONDITIONS: [
      {
        ID: "course",
        NAME: "一時金",
        LABELS: [
          { VALUE: 1, LABEL: "一時金なし" },
          { VALUE: 2, LABEL: "一時金あり" },
        ],
      },
    ],
  },
  {
    ID: "tsumitate",
    CAUTION: "年1回4月募集時のみ(7月1日加入)",
    BEFORE_TITLE: "「将来必要とする資金」を積立てていく保険",
    TITLE: "Kawasaki積立年金",
    AFTER_TITLE:
      "個人年金を準備したい方、個人年金保険料控除を活用して所得税を節税したい方など、<br>目的に合わせた積立が可能です。",
    CONDITIONS: [
      {
        ID: "courseA",
        NAME: "Aコース（税制適格型）",
        LABELS: [
          { VALUE: 2, LABEL: "2口" },
          { VALUE: 3, LABEL: "3口" },
          { VALUE: 4, LABEL: "4口" },
          { VALUE: 5, LABEL: "5口" },
          { VALUE: 6, LABEL: "6口" },
          { VALUE: 7, LABEL: "7口" },
          { VALUE: 8, LABEL: "8口" },
          { VALUE: 9, LABEL: "9口" },
          { VALUE: 10, LABEL: "10口" },
        ],
      },
      {
        ID: "courseB",
        NAME: "Bコース（自由選択型）",
        LABELS: [
          { VALUE: 2, LABEL: "2口" },
          { VALUE: 3, LABEL: "3口" },
          { VALUE: 4, LABEL: "4口" },
          { VALUE: 5, LABEL: "5口" },
          { VALUE: 6, LABEL: "6口" },
          { VALUE: 7, LABEL: "7口" },
          { VALUE: 8, LABEL: "8口" },
          { VALUE: 9, LABEL: "9口" },
          { VALUE: 10, LABEL: "10口" },
        ],
      },
    ],
  },
];
const RECOMMEND_OPTION = [
  {
    LIFESTAGE: 1,
    OPTIONS: {
      seimei: {
        insured: true,
        course: "300万円",
      },
      seikatsu: {
        insured: true,
        medical: "M4",
        cancer: "G1S",
        nursing: "100万円",
        injury: {
          type: "個人型",
          disaster: "天災補償　なし",
          amount: "1口",
        },
        compensation: "あり",
      },
      shushin: {
        insured: false,
        course: "一時金なし",
      },
      tsumitate: {
        insured: false,
        courseA: "5口",
        courseB: null,
      },
    },
  },
  {
    LIFESTAGE: 2,
    OPTIONS: {
      seimei: {
        insured: true,
        course: "1,500万円",
      },
      seikatsu: {
        insured: true,
        medical: "M2",
        cancer: "G1S",
        nursing: "200万円",
        injury: {
          type: "個人型",
          disaster: "天災補償　なし",
          amount: "1口",
        },
        compensation: "あり",
      },
      shushin: {
        insured: false,
        course: "一時金なし",
      },
      tsumitate: {
        insured: false,
        courseA: "5口",
        courseB: null,
      },
    },
  },
  {
    LIFESTAGE: 3,
    OPTIONS: {
      seimei: {
        insured: true,
        course: "3,000万円",
      },
      seikatsu: {
        insured: true,
        medical: "M1",
        cancer: "G1KS",
        nursing: "300万円",
        injury: {
          type: "個人型",
          disaster: "天災補償　なし",
          amount: "1口",
        },
        compensation: "あり",
      },
      shushin: {
        insured: false,
        course: "一時金なし",
      },
      tsumitate: {
        insured: false,
        courseA: "5口",
        courseB: null,
      },
    },
  },
  {
    LIFESTAGE: 4,
    OPTIONS: {
      seimei: {
        insured: true,
        course: "1,000万円",
      },
      seikatsu: {
        insured: true,
        medical: "M1",
        cancer: "G1KS",
        nursing: "300万円",
        injury: {
          type: "個人型",
          disaster: "天災補償　なし",
          amount: "1口",
        },
        compensation: "あり",
      },
      shushin: {
        insured: false,
        course: "一時金なし",
      },
      tsumitate: {
        insured: false,
        courseA: "5口",
        courseB: null,
      },
    },
  },
];
const RISK_BUTTONS = [
  {
    ID: "main",
    BUTTONS: [
      {
        NUM: 1,
        CATEGORY: "life",
        HERE: false,
        PICT: "risk-life.svg",
        LABEL: "<span>生活</span>のリスク",
        NEXT: 'life',
      },
      {
        NUM: 2,
        CATEGORY: "health",
        HERE: false,
        PICT: "risk-health.svg",
        LABEL: "<span>身体</span>のリスク",
        NEXT: 'health',
      },
      {
        NUM: 3,
        CATEGORY: "estate",
        HERE: false,
        PICT: "risk-estate.svg",
        LABEL: "<span>財産</span>のリスク",
        NEXT: 'estate',
      },
      {
        NUM: 4,
        CATEGORY: "car",
        HERE: false,
        PICT: "risk-car.svg",
        LABEL: "<span>車</span>のリスク",
        NEXT: 'car',
      },
    ],
  },
  {
    ID: "life",
    BUTTONS: [
      {
        NUM: 1,
        CATEGORY: "life",
        HERE: true,
        PICT: "risk-life.svg",
        LABEL: "<span>生活</span>のリスク",
      },
      {
        NUM: 2,
        CATEGORY: "life",
        HERE: false,
        SUB: true,
        LABEL: "子ども学資金、<br>車購入、結婚、<br>住宅取得などの<br>大きな出費<br>〈積立年金B〉",
        NEXT: 'tsumitateb',
      },
      {
        NUM: 3,
        CATEGORY: "life",
        HERE: false,
        SUB: true,
        LABEL: "老後の<br>生活費<br>〈積立年金A〉",
        NEXT: 'tsumitatea',
      },
      {
        NUM: 4,
        CATEGORY: "life",
        HERE: false,
        SUB: true,
        LABEL: "日常生活での<br>損害賠償<br>〈個人賠償責任保険〉",
        NEXT: 'compensation',
      },
    ],
  },
  {
    ID: "health",
    BUTTONS: [
      {
        NUM: 1,
        CATEGORY: "health",
        HERE: false,
        SUB: true,
        LABEL: "入院・<br>手術への<br>補償<br>〈Kせいかつ・終身医療〉",
        NEXT: 'seikatsu',
      },
      {
        NUM: 2,
        CATEGORY: "health",
        HERE: true,
        PICT: "risk-health.svg",
        LABEL: "<span>身体</span>のリスク",
      },
      {
        NUM: 3,
        CATEGORY: "health",
        HERE: false,
        SUB: true,
        LABEL: "介護状態時の<br>補償<br>〈Kせいかつ〉",
        NEXT: 'nursing',
      },
      {
        NUM: 4,
        CATEGORY: "health",
        HERE: false,
        SUB: true,
        LABEL: "死亡・ 高度障害の<br>保障<br>〈Kせいめい〉",
        NEXT: 'seimei',
      },
    ],
  },
  {
    ID: "estate",
    BUTTONS: [
      {
        NUM: 1,
        CATEGORY: "estate",
        HERE: false,
        SUB: true,
        LABEL: "持ち物などの<br>損害<br>〈携行品損害〉",
        NEXT: 'damage',
      },
      {
        NUM: 2,
        CATEGORY: "estate",
        HERE: false,
        IMAGE: 'reason-person.png',
      },
      {
        NUM: 3,
        CATEGORY: "estate",
        HERE: true,
        PICT: "risk-estate.svg",
        LABEL: "<span>財産</span>のリスク",
      },
      {
        NUM: 4,
        CATEGORY: "estate",
        HERE: false,
        SUB: true,
        LABEL: "火災や地震<br>などによる<br>建物・家財の<br>損害<br>〈火災保険〉",
        NEXT: 'fire',
      },
    ],
  },
  {
    ID: "car",
    BUTTONS: [
      {
        NUM: 1,
        CATEGORY: "car",
        HERE: false,
        SUB: true,
        LABEL: "お車の<br>補償<br>〈自動車保険〉",
        NEXT: 'car',
      },
      {
        NUM: 2,
        CATEGORY: "car",
        HERE: false,
        SUB: true,
        LABEL: "賠償に関する<br>補償<br>〈自動車保険〉",
        NEXT: 'car',
      },
      {
        NUM: 3,
        CATEGORY: "car",
        HERE: false,
        SUB: true,
        LABEL: "ご自身の<br>補償<br>〈自動車保険〉",
        NEXT: 'car',
      },
      {
        NUM: 4,
        CATEGORY: "car",
        HERE: true,
        PICT: "risk-car.svg",
        LABEL: "<span>車</span>のリスク",
      },
    ],
  },
];

export {
  CRYPTO_PASSPHRASE,
  GENDER_LABELS,
  PERSON_LABELS,
  LIFESTAGE_LABELS,
  INS_PRODUCTS_LABELS,
  RECOMMEND_OPTION,
  PRICE_LIST,
  RISK_BUTTONS,
};
